import classNames from 'classnames';
import { useCallback } from 'react';
import { Button } from 'yoso';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { T } from '~/components/I18n';
import document from '~/components/Icon/document.png';
import { useMember } from '~/components/Member/Member.hooks';
import { Alert, styles as alertStyles } from '~/components/Modal/Alert/Alert';
import { OpenModal } from '~/components/Modal/Open/OpenModal';
import { regularFormat } from '~/components/Util';
import { registerW8benUrl, useW8ben } from '~/components/Wallet/W8ben/W8ben.hooks';
import styles from './W8benOpener.module.scss';

export const W8benOpener = () => {
  const { open: openViewer } = useEmbeddedViewer();
  const {
    data: { isLoggedIn },
  } = useMember();
  const { data: { registrationDeadline } = {}, isFetched } = useW8ben();

  const hasOpened = sessionStorage.getItem('w8ben') === 'true';
  const hasDeadline = isFetched && !!registrationDeadline;
  const disabled = !isLoggedIn || hasOpened || !hasDeadline;
  const onClose = useCallback(
    async ({ confirmed }) => {
      if (confirmed) {
        // NOTE open wallet after current async task
        requestAnimationFrame(() => openViewer(registerW8benUrl));
      }
      sessionStorage.setItem('w8ben', 'true');
    },
    [openViewer]
  );

  return (
    <OpenModal disabled={disabled} onClose={onClose}>
      <Alert
        className={styles.popup}
        icon={<img src={document} width={90} height={90} alt="w8ben registration required" />}
        title={<T name="citizen_land_w8ben_notice_popup_title" />}
        confirmButton={({ confirm }) => (
          <Button
            className={alertStyles.confirmButton}
            color="primary"
            data-event="click"
            data-event-target="required_register_w8ben_btn"
            onClick={confirm}>
            <T name="citizen_button_title_w8ben" />
          </Button>
        )}>
        <p className={styles.deadline}>
          <T name="citizen_land_w8ben_notice_popup_desc1" />:{' '}
          {regularFormat(registrationDeadline, { format: 'P p' })}
        </p>
        <p className={classNames(alertStyles.description, styles.description)}>
          <T name="citizen_land_w8ben_notice_popup_desc2" />
        </p>
      </Alert>
    </OpenModal>
  );
};
